export enum OilSupplierQueryKeys {
  GET_OIL_SUPPLIERS = 'GET_OIL_SUPPLIERS',
  GET_ALL_OIL_SUPPLIERS = 'GET_ALL_OIL_SUPPLIERS',
  GET_OIL_SUPPLIER_DETAIL = 'GET_OIL_SUPPLIER_DETAIL',
}
